// extracted by mini-css-extract-plugin
export default {"grid":"EntityDefinition_grid__61AFK"};